import apiClient from '@/api/client';
import { getActiveHospitalId, getActiveClinicId } from '@/constants';

const STORAGE_KEY_INVOICES = 'pulseflow_invoices';
const STORAGE_KEY_PAYMENTS = 'pulseflow_payments';
const STORAGE_KEY_RECEIPTS = 'pulseflow_receipts';

const INITIAL_SEED_INVOICES = [
  {
    id: 'inv-seed-101',
    invoiceNumber: 'INV-2026-881201',
    hospitalId: 'hosp-1',
    clinicId: 'c-opd',
    patientId: 'pat-001',
    patientName: 'Rajesh Kumar',
    patientCode: 'P-10021',
    doctorId: 'doc-001',
    doctorName: 'Dr. Arun Sharma',
    status: 'PAID',
    subtotal: 500,
    discount: 0,
    taxAmount: 0,
    totalAmount: 500,
    paidAmount: 500,
    balanceAmount: 0,
    source: 'Walk-in',
    items: [
      { id: 'ii-1', description: 'General OPD Consultation Fee', itemType: 'CONSULTATION', quantity: 1, unitPrice: 500, amount: 500 },
    ],
    payments: [
      {
        id: 'pay-seed-1',
        paymentNumber: 'PAY-2026-401121',
        invoiceId: 'inv-seed-101',
        invoiceNumber: 'INV-2026-881201',
        amount: 500,
        paymentMode: 'UPI',
        referenceNumber: 'UPI889210982341',
        paymentDate: new Date().toISOString(),
        receiptNumber: 'RCT-2026-100291',
      },
    ],
    issuedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
  },
  {
    id: 'inv-seed-102',
    invoiceNumber: 'INV-2026-881202',
    hospitalId: 'hosp-1',
    clinicId: 'c-opd',
    patientId: 'pat-002',
    patientName: 'Priya Sharma',
    patientCode: 'P-10022',
    doctorId: 'doc-002',
    doctorName: 'Dr. Meera Patel',
    status: 'PARTIALLY_PAID',
    subtotal: 1200,
    discount: 100,
    taxAmount: 0,
    totalAmount: 1100,
    paidAmount: 600,
    balanceAmount: 500,
    source: 'Online Booking',
    items: [
      { id: 'ii-2', description: 'Specialist Consultation', itemType: 'CONSULTATION', quantity: 1, unitPrice: 700, amount: 700 },
      { id: 'ii-3', description: 'Complete Blood Count (CBC)', itemType: 'LAB', quantity: 1, unitPrice: 500, amount: 500 },
    ],
    payments: [
      {
        id: 'pay-seed-2',
        paymentNumber: 'PAY-2026-401122',
        invoiceId: 'inv-seed-102',
        invoiceNumber: 'INV-2026-881202',
        amount: 600,
        paymentMode: 'CASH',
        referenceNumber: 'CASH-REC-01',
        paymentDate: new Date().toISOString(),
        receiptNumber: 'RCT-2026-100292',
      },
    ],
    issuedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
  },
  {
    id: 'inv-seed-103',
    invoiceNumber: 'INV-2026-881203',
    hospitalId: 'hosp-1',
    clinicId: 'c-opd',
    patientId: 'pat-003',
    patientName: 'Amit Verma',
    patientCode: 'P-10023',
    doctorId: 'doc-001',
    doctorName: 'Dr. Arun Sharma',
    status: 'PAID',
    subtotal: 850,
    discount: 0,
    taxAmount: 0,
    totalAmount: 850,
    paidAmount: 850,
    balanceAmount: 0,
    source: 'Walk-in',
    items: [
      { id: 'ii-4', description: 'Consultation Fee', itemType: 'CONSULTATION', quantity: 1, unitPrice: 500, amount: 500 },
      { id: 'ii-5', description: 'Wound Dressing & Antiseptic', itemType: 'PROCEDURE', quantity: 1, unitPrice: 350, amount: 350 },
    ],
    payments: [
      {
        id: 'pay-seed-3',
        paymentNumber: 'PAY-2026-401123',
        invoiceId: 'inv-seed-103',
        invoiceNumber: 'INV-2026-881203',
        amount: 850,
        paymentMode: 'CARD',
        referenceNumber: 'POS-AUTH-7712',
        paymentDate: new Date().toISOString(),
        receiptNumber: 'RCT-2026-100293',
      },
    ],
    issuedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
  },
  {
    id: 'inv-seed-104',
    invoiceNumber: 'INV-2026-881204',
    hospitalId: 'hosp-1',
    clinicId: 'c-opd',
    patientId: 'pat-004',
    patientName: 'Sunita Reddy',
    patientCode: 'P-10024',
    doctorId: 'doc-003',
    doctorName: 'Dr. Suresh Rao',
    status: 'PENDING',
    subtotal: 750,
    discount: 0,
    taxAmount: 0,
    totalAmount: 750,
    paidAmount: 0,
    balanceAmount: 750,
    source: 'Referral',
    items: [
      { id: 'ii-6', description: 'Cardiology Consultation', itemType: 'CONSULTATION', quantity: 1, unitPrice: 750, amount: 750 },
    ],
    payments: [],
    issuedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
  },
];

const getStoredInvoices = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY_INVOICES) || '[]');
    const raw = localStorage.getItem(STORAGE_KEY_INVOICES);
    if (!raw) {
      localStorage.setItem(STORAGE_KEY_INVOICES, JSON.stringify(INITIAL_SEED_INVOICES));
      return INITIAL_SEED_INVOICES;
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) {
      localStorage.setItem(STORAGE_KEY_INVOICES, JSON.stringify(INITIAL_SEED_INVOICES));
      return INITIAL_SEED_INVOICES;
    }
    return parsed;
  } catch (e) {
    return [];
    return INITIAL_SEED_INVOICES;
  }
};

const saveStoredInvoices = (invoices) => {
  try {
    localStorage.setItem(STORAGE_KEY_INVOICES, JSON.stringify(invoices));
  } catch (e) {
    console.error('Failed to persist invoices', e);
  }
};

export const generateInvoiceNumber = () => {
  const year = new Date().getFullYear();
  const rand = Math.floor(100000 + Math.random() * 900000);
  return `INV-${year}-${rand}`;
};

export const generateReceiptNumber = () => {
  const year = new Date().getFullYear();
  const rand = Math.floor(100000 + Math.random() * 900000);
  return `RCT-${year}-${rand}`;
};

export const invoiceService = {
  /**
   * GET /pms/hospital/{hospitalId}/clinic/{clinicId}/invoices
   */
  getAll: async (params = {}, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(params.clinicId);

    try {
      const res = await apiClient.get(
        `/hospital/${activeHospId}/clinic/${activeClinicId}/invoices`,
        { params }
      );
      if (res && (res.data || res.content)) {
        return {
          data: res.data || res.content,
          total: res.totalElements || (res.data || res.content).length,
        };
      }
    } catch (e) {
      // Fallback
    }

    let items = getStoredInvoices();
    if (params.patientId) {
      items = items.filter((inv) => inv.patientId === params.patientId);
    }
    if (params.status && params.status !== 'all') {
      items = items.filter((inv) => inv.status === params.status);
    }
    return { data: items, total: items.length };
  },

  /**
   * Comprehensive Payment Report and Analytics
   */
  getPaymentReport: async function (filters = {}, hospitalId) {
    const allInvoicesRes = await this.getAll({}, hospitalId);
    let invoices = allInvoicesRes.data || [];

    // Filter by Date
    const { dateRangeType = 'day', targetDate, startDate, endDate } = filters;

    invoices = invoices.filter((inv) => {
      const invDateStr = (inv.issuedAt || inv.createdAt || '').split('T')[0];
      if (!invDateStr) return true;

      if (dateRangeType === 'day') {
        const checkDate = targetDate || new Date().toISOString().split('T')[0];
        return invDateStr === checkDate;
      }

      if (dateRangeType === 'week') {
        const curr = targetDate ? new Date(targetDate) : new Date();
        const first = curr.getDate() - curr.getDay() + (curr.getDay() === 0 ? -6 : 1); // Monday
        const last = first + 6; // Sunday
        const monday = new Date(curr.setDate(first)).toISOString().split('T')[0];
        const sunday = new Date(curr.setDate(last)).toISOString().split('T')[0];
        return invDateStr >= monday && invDateStr <= sunday;
      }

      if (dateRangeType === 'month') {
        const checkDate = targetDate ? new Date(targetDate) : new Date();
        const yearMonth = `${checkDate.getFullYear()}-${String(checkDate.getMonth() + 1).padStart(2, '0')}`;
        return invDateStr.startsWith(yearMonth);
      }

      if (dateRangeType === 'custom') {
        if (startDate && invDateStr < startDate) return false;
        if (endDate && invDateStr > endDate) return false;
        return true;
      }

      return true;
    });

    // Filter by Paid Via
    if (filters.paidVia && filters.paidVia !== 'all') {
      invoices = invoices.filter((inv) => {
        return (inv.payments || []).some(
          (p) => p.paymentMode?.toUpperCase() === filters.paidVia.toUpperCase()
        );
      });
    }

    // Filter by Settlement Status
    if (filters.status && filters.status !== 'all') {
      invoices = invoices.filter((inv) => inv.status === filters.status);
    }

    // Filter by Search Query
    if (filters.search) {
      const q = filters.search.toLowerCase();
      invoices = invoices.filter(
        (inv) =>
          inv.invoiceNumber?.toLowerCase().includes(q) ||
          inv.patientName?.toLowerCase().includes(q) ||
          inv.patientCode?.toLowerCase().includes(q) ||
          inv.doctorName?.toLowerCase().includes(q)
      );
    }

    // Compute KPI Aggregates
    const earnings = invoices.reduce((sum, inv) => sum + (Number(inv.totalAmount) || 0), 0);
    const settled = invoices.reduce((sum, inv) => sum + (Number(inv.paidAmount) || 0), 0);
    const toBeSettled = invoices.reduce((sum, inv) => sum + (Number(inv.balanceAmount) || 0), 0);

    // Compute Payment Mode breakdown
    const byMode = {
      UPI: { amount: 0, count: 0 },
      CASH: { amount: 0, count: 0 },
      CARD: { amount: 0, count: 0 },
      BANK_TRANSFER: { amount: 0, count: 0 },
      CHEQUE: { amount: 0, count: 0 },
      OTHER: { amount: 0, count: 0 },
    };

    invoices.forEach((inv) => {
      (inv.payments || []).forEach((p) => {
        const mode = (p.paymentMode || 'OTHER').toUpperCase();
        if (!byMode[mode]) {
          byMode[mode] = { amount: 0, count: 0 };
        }
        byMode[mode].amount += Number(p.amount) || 0;
        byMode[mode].count += 1;
      });
    });

    return {
      earnings,
      settled,
      toBeSettled,
      totalCount: invoices.length,
      byMode,
      invoices,
    };
  },

  /**
   * GET /pms/hospital/{hospitalId}/clinic/{clinicId}/invoices/{id}
   */
  getById: async (id, clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);

    try {
      const res = await apiClient.get(
        `/hospital/${activeHospId}/clinic/${activeClinicId}/invoices/${id}`
      );
      return res.data || res;
    } catch (e) {
      const items = getStoredInvoices();
      return items.find((inv) => inv.id === id || inv.invoiceNumber === id) || null;
    }
  },

  /**
   * GET invoice linked to a specific consultation
   */
  getByConsultationId: async (consultationId, clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);

    try {
      const res = await apiClient.get(
        `/hospital/${activeHospId}/clinic/${activeClinicId}/consultations/${consultationId}/invoice`
      );
      return res.data || res;
    } catch (e) {
      const items = getStoredInvoices();
      return items.find((inv) => inv.consultationId === consultationId) || null;
    }
  },

  /**
   * POST /pms/hospital/{hospitalId}/clinic/{clinicId}/consultations/{consultationId}/invoice
   */
  createForConsultation: async (consultationId, data, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(data.clinicId);

    const items = (data.items || []).map((item, idx) => {
      const qty = Number(item.quantity) || 1;
      const price = Number(item.unitPrice) || 0;
      return {
        id: `ii-${Date.now()}-${idx}`,
        description: item.description || 'Clinical Service',
        itemType: item.itemType || 'CONSULTATION',
        quantity: qty,
        unitPrice: price,
        amount: qty * price,
        displayOrder: idx + 1,
      };
    });

    const subtotal = items.reduce((sum, it) => sum + it.amount, 0);
    const discount = Number(data.discount) || 0;
    const taxAmount = Number(data.taxAmount) || 0;
    const totalAmount = Math.max(0, subtotal - discount + taxAmount);

    const newInvoice = {
      id: `inv-${Date.now()}`,
      invoiceNumber: generateInvoiceNumber(),
      hospitalId: activeHospId,
      clinicId: activeClinicId,
      patientId: data.patientId,
      patientName: data.patientName || '',
      patientCode: data.patientCode || '',
      consultationId: consultationId,
      doctorId: data.doctorId,
      doctorName: data.doctorName || '',
      status: 'PENDING', // PENDING, PARTIALLY_PAID, PAID, CANCELLED
      subtotal,
      discount,
      taxAmount,
      totalAmount,
      paidAmount: 0.0,
      balanceAmount: totalAmount,
      items,
      payments: [],
      issuedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
      notes: data.notes || '',
    };

    try {
      const res = await apiClient.post(
        `/hospital/${activeHospId}/clinic/${activeClinicId}/consultations/${consultationId}/invoice`,
        newInvoice
      );
      return res.data || res;
    } catch (e) {
      const current = getStoredInvoices();
      const updated = [newInvoice, ...current.filter((inv) => inv.consultationId !== consultationId)];
      saveStoredInvoices(updated);
      return newInvoice;
    }
  },

  /**
   * POST /pms/hospital/{hospitalId}/clinic/{clinicId}/invoices/{invoiceId}/payments
   */
  recordPayment: async (invoiceId, paymentData, clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);

    const paymentAmount = Number(paymentData.amount) || 0;
    if (paymentAmount <= 0) {
      throw new Error('Payment amount must be greater than zero');
    }

    const payload = {
      amount: paymentAmount,
      paymentMode: paymentData.paymentMode || 'CASH',
      referenceNumber: paymentData.referenceNumber || '',
      notes: paymentData.notes || '',
      paymentDate: new Date().toISOString(),
    };

    try {
      const res = await apiClient.post(
        `/hospital/${activeHospId}/clinic/${activeClinicId}/invoices/${invoiceId}/payments`,
        payload
      );
      return res.data || res;
    } catch (e) {
      const invoices = getStoredInvoices();
      const invIndex = invoices.findIndex((inv) => inv.id === invoiceId);
      if (invIndex === -1) {
        throw new Error('Invoice not found');
      }

      const inv = invoices[invIndex];
      if (paymentAmount > inv.balanceAmount + 0.01) {
        throw new Error(
          `Payment amount (₹${paymentAmount}) cannot exceed outstanding balance (₹${inv.balanceAmount})`
        );
      }

      const newPaid = Number((inv.paidAmount + paymentAmount).toFixed(2));
      const newBalance = Number(Math.max(0, inv.totalAmount - newPaid).toFixed(2));
      const newStatus = newBalance === 0 ? 'PAID' : 'PARTIALLY_PAID';

      const paymentRecord = {
        id: `pay-${Date.now()}`,
        paymentNumber: `PAY-${new Date().getFullYear()}-${Math.floor(100000 + Math.random() * 900000)}`,
        invoiceId: inv.id,
        invoiceNumber: inv.invoiceNumber,
        amount: paymentAmount,
        paymentMode: payload.paymentMode,
        referenceNumber: payload.referenceNumber,
        notes: payload.notes,
        paymentDate: payload.paymentDate,
        receiptNumber: generateReceiptNumber(),
      };

      inv.paidAmount = newPaid;
      inv.balanceAmount = newBalance;
      inv.status = newStatus;
      inv.payments = [...(inv.payments || []), paymentRecord];
      invoices[invIndex] = inv;
      saveStoredInvoices(invoices);

      return {
        invoice: inv,
        payment: paymentRecord,
      };
    }

  },



  downloadInvoicePdf: async (invoiceId, clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);
    const response = await apiClient.get(
      `/hospital/${activeHospId}/clinic/${activeClinicId}/invoices/${invoiceId}/pdf`,
      { responseType: 'blob' }
    );
    const disposition = response.headers['content-disposition'];
    const filename = disposition?.match(/filename="?([^";]*)"?/)?.[1] || `invoice-${invoiceId}.pdf`;
    return { blob: response.data, filename };
  },
  downloadReceiptPdf: async (paymentId, clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);
    const response = await apiClient.get(
      `/hospital/${activeHospId}/clinic/${activeClinicId}/payments/${paymentId}/receipt/pdf`,
      { responseType: 'blob' }
    );
    const disposition = response.headers['content-disposition'];
    const filename = disposition?.match(/filename="?([^";]*)"?/)?.[1] || `receipt-${paymentId}.pdf`;
    return { blob: response.data, filename };
  },
};

export default invoiceService;

